import { api } from "./api";

export async function completePersonalizationRequestFromLocation(result: {
  resourceType: string;
  resourceId: string;
}) {
  const params = new URLSearchParams(window.location.search);
  const requestId = params.get("personalizationRequestId");
  if (!requestId) return false;
  await api(
    `/personalization/requests/${encodeURIComponent(requestId)}/complete`,
    {
      method: "POST",
      body: JSON.stringify({ result }),
    },
  );
  params.delete("personalizationRequestId");
  const nextQuery = params.toString();
  window.history.replaceState(
    {},
    "",
    `${window.location.pathname}${nextQuery ? `?${nextQuery}` : ""}`,
  );
  return true;
}

export type PersonalSkillPlan = {
  action: string;
  status: string;
  request: {
    slug?: string;
    name?: string;
    description?: string;
    instructions?: string;
    makeDefault?: boolean;
  };
};

export async function personalSkillPlanFromLocation(): Promise<PersonalSkillPlan | null> {
  const requestId = new URLSearchParams(window.location.search).get(
    "personalizationRequestId",
  );
  if (!requestId) return null;
  const plan = await api<PersonalSkillPlan>(
    `/personalization/requests/${encodeURIComponent(requestId)}`,
  );
  if (plan.status !== "pending" && plan.status !== "approved")
    throw new Error(
      "This setup plan is no longer active. Return to Personalization to create a new plan.",
    );
  if (plan.action === "create_executable_skill")
    throw new Error(
      "Executable skills require administrator review. This form creates instruction-only skills; return to Personalization for the review workflow.",
    );
  return plan.action === "create_personal_skill" ? plan : null;
}
